const generos = [
  'Masculino',
  'Feminino',
  'Homem Transgênero',
  'Mulher Transgênero',
  'Homem Transexual',
  'Mulher Transexual',
  'Não sei responder',
  'Prefiro não responder',
  'Outros'
]

export default generos